<template>
  <div class="wx-open-message-configure-pub"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="categories">
      <template v-if="categories.length">
        <div class="pub-main">
          <div class="header">
            <div class="label">
              <span>目前配置类目：</span>
            </div>
            <div class="value">
              <el-tag v-for="category in categories"
                      :key="category.id"
                      size="mini"
                      type="primary">{{category.name}}</el-tag>
            </div>
          </div>
          <div class="main">
            <div class="main-cont">
              <WxOpenMessageConfigurePubQuery :categories="categories"></WxOpenMessageConfigurePubQuery>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <Hint>
          <div>公众号未配置服务类目</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>类目数据加载失败</div>
        <el-button type="text"
                   @click="loadCategories">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import WxOpenMessageConfigurePubQuery from './query'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'WxOpenMessageConfigurePub',
  components: {
    WxOpenMessageConfigurePubQuery,
    Hint
  },
  data () {
    return {
      loading: false,
      categories: null,
      pubTemplate: null
    }
  },
  methods: {
    loadCategories () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/open/categories',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.categories = response.data['categories'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadCategories()
  }
}
</script>

<style lang="scss">
  .wx-open-message-configure-pub {
    height: 100%;
    background-color: #fff;
    & > .pub-main {
      height: 100%;
      display: flex;
      flex-direction: column;
      & > .header {
        flex: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        & > .label {
          font-size: 12px;
        }
        & > .value {
          .el-tag {
            & + .el-tag {
              margin-left: 10px;
            }
          }
        }
      }
      & > .main {
        flex: auto;
        position: relative;
        & > .main-cont {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
</style>
